var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(_vm.hidden)?_c('div',{staticClass:"btn-wrap",on:{"click":function($event){return _vm.goto('/partner')}}},[_c('img',{attrs:{"src":require("@/assets/imgs/product/ori_icon.png")}}),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.$t("index.合作伙伴申请")))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }